import React, {
  createContext,
  useState,
  Dispatch,
  SetStateAction,
  ReactNode,
} from 'react';
import { FlashPackLocale, getCurrentLocale } from '../../utils/RegionDetection';

interface LocaleContextType {
  locale: FlashPackLocale;
  setLocale: Dispatch<SetStateAction<FlashPackLocale>>;
}

export const LocaleContext = createContext<LocaleContextType>({
  locale: { country: 'uk', currencyCode: 'gbp' },
  setLocale: () => {},
});

export const LocaleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const defaultLocale = getCurrentLocale();
  const [locale, setLocale] = useState(defaultLocale);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
